<template>
  <div
    class="dropdown-content"
    style="margin-left: -7px; z-index: 9; padding-bottom: 10px !important"
  >
    <div class="row">
      <div class="content" style="position: relative; display: flex">
        <a
          :href="customer.customer_lnk"
          v-html="customer.customer_img"
          v-if="
            contact_data &&
            (contact_data.credentials || {}).hasViewCustomerProfile
          "
        ></a>
        <p v-html="customer.customer_img" v-else></p>
        <div class="text" style="padding-left: 5px">
          <h3 class="deleteMarginMobView">
            <strong
              style="font-size: 15px"
              v-if="contact_data && contact_data.contact_name"
            >
              <a
                :href="customer.customer_lnk"
                v-if="(contact_data.credentials || {}).hasViewCustomerProfile"
                style="text-decoration: none; color: #2e4051"
              >
                {{ contact_data.contact_name }}
              </a>
              <p v-else>
                {{ contact_data.contact_name }}
              </p>
            </strong>
          </h3>
          <p
            style="
              font-size: 12px;
              font-weight: 500;
              padding-top: 5px;
              padding-left: 1px;
            "
            v-if="
              contact_data &&
              (contact_data.credentials || {}).hasViewCustomerProfile
            "
          >
            <a
              :href="customer.customer_lnk"
              class="details_info_name FontSize"
              style="font-weight: bold"
            >
              <p
                class="BusiNmaePaddingMobPhone"
                v-html="customer.customer_business_name"
              ></p>
              <b class="BusiNmaePaddingMobPhone">View profile</b>
            </a>
          </p>
        </div>
      </div>
    </div>
    <div class="row customerInfoA" style="padding-top: 15px">
      <customer-call-btn
        class="m-right-15"
        theme="rectangle"
        :call_target="contact_data.call_target"
        :mobile_link="contact_data.mobile_link"
        :call_web_link="contact_data.call_web_link"
        :customer_name_without_quote="contact_data.contact_name_without_quote"
        :customer_numbers="contact_data.customer_numbers"
        :item-type="itemType"
        :hasViewCredential="
          (contact_data.credentials || {}).hasViewCustomerCredential
        "
        v-if="contact_data && (contact_data.credentials || {}).calls"
      />

      <customer-send-email-btn
        class="m-right-15"
        v-if="contact_data && (contact_data.credentials || {}).send_email"
        theme="rectangle"
        :email_link="contact_data.email_link"
        :customer-id="customer.customer_id"
        :contact-id="contact_data?.id"
        :invoice-id="invoiceId"
        :booking-info="bookingInfo"
        :booking-id="bookingId"
        :estimate-id="estimateId"
        :item-type="itemType"
        :has-estimate="hasEstimate"
        :from-booking="fromBooking"
        :from-quote="fromQuote"
        :from-inquiry="fromInquiry"
      />

      <customer-send-sms-btn
        class="m-right-15"
        v-if="contact_data && (contact_data.credentials || {}).send_sms"
        theme="rectangle"
        :sms_link="contact_data.sms_link"
        :customer-id="customer.customer_id"
        :invoice-id="invoiceId"
        :booking-info="bookingInfo"
        :booking-id="bookingId"
        :from-booking="fromBooking"
        :item-type="itemType"
        :from-quote="fromQuote"
        :estimate-id="estimateId"
        :has-estimate="hasEstimate"
        :from-inquiry="fromInquiry"
      />

      <customer-chat-btn
        class="m-right-15"
        theme="rectangle"
        :discussion_lnk="contact_data.discussion_lnk"
        v-if="
          contact_data &&
          (contact_data.credentials || {}).hasCustomerDisscussionCredenetial
        "
      />
    </div>

    <div class="row m-top-5" v-if="contact_data && contact_data.note">
      <li
        style="border: 1px solid transparent; white-space: normal !important"
        class="btn btn-success btn-rounded blue-label-btn li-note-show-content_3"
        @click="expand = !expand"
      >
        <span>
          {{
            expand
              ? contact_data.note
              : contact_data.note.length > 20
              ? contact_data.note.substr(0, 20) + "..."
              : contact_data.note
          }}
        </span>
      </li>
    </div>
  </div>
</template>
<script>
export default {
  name: "CustomerDropdown",
  props: [
    "customer",
    "contact_data",
    "invoiceId",
    "bookingId",
    "bookingInfo",
    "estimateId",
    "hasEstimate",
    "fromBooking",
    "fromInquiry",
    "fromQuote",
    "itemType",
  ],
  data() {
    return {
      expand: false,
    };
  },
};
</script>

<style>
.dropdown-content {
  height: auto !important;
  padding-bottom: 0px;
}

.m-b-5 {
  margin-bottom: 5px;
}

.dropdown-content a {
  padding: 0px !important;
}
</style>
